import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UpsCommonService } from '../../services/upplm.common.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { ServiceURLConstants, ApiErrorCode } from '../../constants/upplm.constants';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';

@Component({
    selector: 'approveconfirmed',
    template: require('./approveConfirmed.component.html')
})

export class ApproveConfirmedComponent implements OnInit {

    public isLoading: boolean = true;
    public placardID: string = '';
    public sessionData: SessionResponse;

    constructor(private router: Router,
        private _activatedRoute: ActivatedRoute,
        private _commonService: UpsCommonService,
        private _sessionService: UpplmSessionService) {
    }

    ngOnInit() {
        this.isLoading = true;

        this.placardID = this._activatedRoute.snapshot.queryParamMap.get('placardid')
        if (this.placardID !== null) {
            document.location.href = 'https://www.ups.com/us/en/pagenotfound.page';
        }

        this.sessionData = this._sessionService.sessionData;
        let request = this.createSessionRequest();
        let requestImg = request.placardConfirmation.placardImage;
        delete request.placardConfirmation.placardImage;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), request).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key) { //There is session data
                response.placardConfirmation.placardImage = requestImg;
                this._sessionService.mapSessionResponse(response);
                this.sessionData = response;

                if (this.sessionData.isApproved && (this.sessionData.placardID !== null || this.sessionData.placardID.length > 0)) {
                    this.placardID = this.sessionData.placardConfirmation.placardId;
                    this.isLoading = false;
                }
                else {
                    document.location.href = 'https://www.ups.com/us/en/pagenotfound.page';
                }
            }
            else { //No session Data, any attempt is send to Page Not Found
                document.location.href = 'https://www.ups.com/us/en/pagenotfound.page';
                this.isLoading = false;
            }
            this.isLoading = false;
        });
    }

    createSessionRequest(): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.locationDetails = this.sessionData.locationDetails;
        request.placardConfirmation = this.sessionData.placardConfirmation;
        request.placardID = this.sessionData.placardID;
        request.isApproved = this.sessionData.isApproved;
        request.lastTimeSessionReqired = new Date().toString();
        return request;
    }
}